<template>
  <div>
    <div class="card" v-if="list">
      <el-card class="el-card" :class="{ 'active-card': isActive }">
        <div slot="header" class="card-header">
          <span class="span">{{ list.planName }}</span>
          <el-tag v-if="list.planEnable === 'Y'" effect="dark" class="el-tag" type="success">启用</el-tag>
          <el-tag v-if="list.planEnable === 'N'" effect="dark" class="el-tag" type="info">禁用</el-tag>
          <el-dropdown class="el-dropdown" @command="handleCommand">
            <!-- :disabled="disabled || deviceStatus !== '1'" -->
            <span class="el-dropdown-link">
              <i class="el-icon-more"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit">编辑</el-dropdown-item>
              <el-dropdown-item command="delete">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="card-content">
          <!-- <p class="card-p" v-if="list.startDate && list.endDate">计划周期
          <span class="carrd-s">{{ list.startDate }}</span>至<span class="carrd-s">{{ list.endDate }}</span>
        </p> -->
          <p class="card-p">计划时间
            <span class="carrd-s">{{ list.startTime }}</span>至<span class="carrd-s">{{ list.endTime }}</span>
          </p>
          <p class="card-p">开启频率
            <span class="carrd-s">{{ getSelectedDays() }}</span>
          </p>
        </div>
      </el-card>
    </div>
    <div v-else>
      <el-empty description="暂无定时计划" :image-size="120">
        <template slot="image">
          <img src="../../../assets/img/nodata.png" alt="">
        </template>
      </el-empty>
    </div>
  </div>

</template>

<script>
export default {
  name: 'mistforestPlanList',
  props: {
    list: {
      type: Object
    },
    isActive: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    deviceStatus: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      options: [
        {
          value: 1,
          label: '周一'
        },
        {
          value: 2,
          label: '周二'
        },
        {
          value: 4,
          label: '周三'
        },
        {
          value: 8,
          label: '周四'
        },
        {
          value: 16,
          label: '周五'
        },
        {
          value: 32,
          label: '周六'
        },
        {
          value: 64,
          label: '周日'
        }
      ],
      intervalDays: ''
    }
  },
  methods: {
    // 选中的天数
    getSelectedDays() {
      if (this.list) {
        this.intervalDays = this.list.intervalDays
        if (this.intervalDays === '127') {
          return '每天'
        } else {
          return this.options.filter(opt => (this.intervalDays & opt.value) !== 0).map(item => item.label).join(',')
        }
      }
    },
    // 操作
    handleCommand(command) {
      console.log(this.list, 'list操作');
      if (command === 'edit') {
        this.$emit('update', this.list)
      } else if (command === 'delete') {
        this.$confirm('确认删除该计划吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post(this.$apis.iot.deleteJgSprayPlan, {
            planId: this.list.planId
          }).then(() => {
            this.$message({ message: '删除成功', type: 'success' })
            this.$emit('delete')
          })
        })
      }
    }
  },
  created() {
    console.log(this.list, 'list列表');
  }
}
</script>
<style lang="scss" scoped>
.card {
  width: 98%;
}

.active-card {
  border: 1px solid #1ad1b0;

  ::v-deep .el-card__header {

    padding: 10px 15px;
    background: #E8FAF7;

  }
}

::v-deep .el-card__header {

  padding: 10px 15px;
  background: #F6F7FB;

  &.active {
    background: #E8FAF7;
  }
}

.active {
  background: #E8FAF7;
}

.el-card {
  width: 100%;
  margin: 10px 1px 1px;
}

.card-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}


.span {
  width: 60%;
}

.el-tag {
  width: 15%;
  margin: 0 auto;
  text-align: center;
}

.card-content {
  width: 100%;
}

.el-dropdown {
  width: 10%;
}

.card-p {
  display: flex;
  gap: 10px;
  font-size: 13px;
  height: 24px;
  line-height: 24px;
}

.card-s {
  width: 90px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.card-cont-tag {
  margin: 0 auto;
  text-align: center;
  font-size: 12px;
}
</style>